import { ICompanyInfo, ILocalCompanyInfo, ENTITY_TYPES } from 'types/carrier'

export const entityTypeOptions = Object.keys(ENTITY_TYPES).map((key: string) => ({
  label: ENTITY_TYPES[key as keyof typeof ENTITY_TYPES],
  value: key,
}))

export const carbCompliant = [
  { label: 'Unknown', value: 'unknown', id: 'unknown-carb' },
  { label: 'Yes', value: 'yes', id: 'yes-carb' },
  { label: 'No', value: 'no', id: 'no-carb' },
]

export const disadvantagedBusinessEntity = [
  { label: 'Unknown', value: 'unknown', id: 'unknown-disadvantaged' },
  { label: 'Yes', value: 'yes', id: 'yes-disadvantaged' },
  { label: 'No', value: 'no', id: 'no-disadvantaged' },
]

export const convertToBoolean = (attribute: ILocalCompanyInfo['eldCompliant']) => {
  if (attribute === 'yes') return true
  if (attribute === 'no') return false

  return null
}

export const convertToString = (attribute: ICompanyInfo['eldCompliant']) => {
  if (attribute === null) return 'unknown'
  return attribute ? 'yes' : 'no'
}
